export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const GET_LOGIN = 'GET_LOGIN';
export const GET_CTA = 'GET_CTA';

export const POST_TERCERO = 'POST_TERCERO';
export const POST_ADDCTATOTERCERO = 'POST_ADDCTATOTERCERO';
export const POST_REMOVE_CTA_TERCERO = 'POST_REMOVE_CTA_TERCERO';
export const POST_TERCERO_PASSUDP = 'POST_TERCERO_PASSUDP';
export const POST_RECUPERAR_PASSWORD = 'POST_RECUPERAR_PASSWORD';
export const POST_CUENTA_DETALLE_LIMPIAR = 'POST_CUENTA_DETALLE_LIMPIAR';

export const GET_CTASTERCERO = 'GET_CTASTERCERO';
export const GET_CONTADORDETALLE = 'GET_CONTADORDETALLE';
export const GET_CONTADOR_DETALLE_MES = 'GET_CONTADOR_DETALLE_MES';
export const GET_CONTADOR_DETALLE_DIA = 'GET_CONTADOR_DETALLE_DIA';



//RAMA JUDICIAL
export const GET_PROCESOS = 'GET_PROCESOS';
export const GET_PROCESOS_COD = 'GET_PROCESOS_COD';
export const GET_COD_PROCESO = 'GET_COD_PROCESO';

export const GET_MAGISTRADO = 'GET_MAGISTRADO';
export const GET_DEMANDANTE = 'GET_DEMANDANTE';
export const GET_DEMANDADO = 'GET_DEMANDADO';
export const GET_INSTANCIA = 'GET_INSTANCIA';
export const GET_ACCION = 'GET_ACCION';
export const GET_DESCRIPTOR = 'GET_DESCRIPTOR';
export const GET_RESTRICTOR = 'GET_RESTRICTOR';
export const GET_DECISION = 'GET_DECISION';

export const POST_PROVIDENCIA = 'POST_PROVIDENCIA';
export const POST_DELETE_PROCESO = 'POST_DELETE_PROCESO';


//Command Palette: Ctrl + (shift) + p
//transform 


